<template>
  <table class="history">
    <tr
      v-for="(item, index) in items"
      :key="index"
    >
      <td>
        <div class="history-icon">
          <span>
            <font-awesome-icon
              :icon="['far', getEventTypeIcon(item.eventType)]"
              size="lg"
            />
          </span>
        </div>
      </td>
      <td>
        <p class="title">
          {{ camelCaseToCapitalize(item.eventType) }} {{ item.by ? `by ${item.by}` : '' }}
        </p>
        <p class="subtitle">
          {{ item.on | dateFormat }} ({{ timezoneEnv }})
        </p>
      </td>
    </tr>
  </table>
</template>

<script>
import { phraseStyles } from '../mixins/phraseStyles'
import { systemTimezone } from '../constants/general'
export default {
  name: 'History',
  mixins: [phraseStyles],
  props: {
    items: Array
  },
  data () {
    return {
      timezoneEnv: ''
    }
  },
  mounted () {
    this.timezoneEnv = systemTimezone()
  },
  methods: {
    getEventTypeIcon (eventType) {
      let icon = 'server'
      switch (eventType) {
        // Campaign
        case 'Created':
          icon = 'plus'
          break
        case 'Cancelled':
          icon = 'times'
          break
          // Approval
        case 'ProceedForApprovalRequested':
        case 'ApprovalRequested':
          icon = 'comment-alt-check'
          break
        case 'Approved':
          icon = 'check'
          break
        case 'Disapproved':
          icon = 'times'
          break
          // Schedule
        case 'CampaignScheduleActivated':
        case 'CampaignScheduleDeactivated':
        case 'Rescheduled':
        case 'Scheduled':
          icon = 'calendar-alt'
          break
        case 'SendHistory':
          icon = 'paper-plane'
          break
          // Audience
        case 'CriteriaChanged':
          icon = 'users'
          break
        case 'DeliverabilityReportRequested':
        case 'InboxPreviewRequested':
        case 'SendToTestEmailsRequested':
          icon = 'tasks'
          break
          // Misc
        case 'OtherChange':
          icon = 'pen'
          break
          // Template
        case 'TemplateChanged':
        case 'TemplateUpdated':
          icon = 'object-group'
          break
          // Other
        case 'ResponsiveCodingRequested':
          icon = 'exclamation-circle'
          break
        default:
          icon = 'server'
      }
      return icon
    }
  }
}
</script>

<style lang="scss" scoped>
  table.history {
    margin: 13px 0 0 0;

    td {
      vertical-align: top;

      .title {
        color: #000;
        margin-bottom: 6px;
        line-height: 21px;
      }

      .subtitle {
        color: #666;
        margin: 0;
      }

      &:first-child {
        width: 62px !important;
        padding-bottom: 38px;

        .history-icon {
          width: 38px;
          position: relative;

          svg {
            vertical-align: 0;
          }

          &:after {
            content: '';
            border-right: 1px solid #D7D7E1;
            height: 50px;
            width: 1px;
            position: absolute;
            left: 50%;
          }

          span {
            background: #E0E0EB;
            border-radius: 50px;
            padding: 8px;
            color: #24245A;
            height: 38px;
            width: 38px;
            display: block;
            text-align: center;
          }
        }
      }
    }

    tr:last-child {
      td:first-child {
        padding-bottom: 0px;

        .history-icon {
          &:after {
            content: unset;
          }
        }
      }
    }
  }
</style>
